import angular from "angular";
import EmailComponent from "./email/email";
import ProfilePageComponent from "./profile-page/profile-page";

const ProfileModule = angular
  .module("modules.profile", [])
  .component("email", EmailComponent)
  .component("profilePage", ProfilePageComponent);

export default ProfileModule;
